import { map, Observable, take, timer } from 'rxjs';

export const countDownObservable = (seconds: number): Observable<number> => {
  return timer(0, 1000).pipe(
    take(seconds + 1),
    map((sec) => seconds - sec)
  );
};
